import Image from "../../../assets/img.png";
import Map from "../../../assets/map.png";
import Friend from "../../../assets/friend.png";

const ShareActions = ({ onOpenModal }) => {
    return (
        <div className="bottom">
            <div className="left">
                <div className="item" onClick={onOpenModal}>
                    <img src={Image} alt="Add Image" />

                    <span>
                        Add Image
                    </span>
                </div>

                <div className="item" onClick={onOpenModal}>
                    <img src={Map} alt="Add Place" />

                    <span>
                        Add Place
                    </span>
                </div>

                <div className="item" onClick={onOpenModal}>
                    <img src={Friend} alt="Tag Friend" />

                    <span>
                        Tag Friend
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ShareActions;